import { UPDATE_SIDEBAR_STATUS } from "../actionTypes";

const initialState = {
  isOpen: false,
};

const getSideBarStatus = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SIDEBAR_STATUS:
      return {
        ...state,
        isOpen: action.payload.isOpen,
      };
    default:
      break;
  }

  return state;
};

export default getSideBarStatus;
